import {
	combineReducers
}from '@reduxjs/toolkit'
import reOrgConstructionMaterialReducer from '../../containers/ReOrgConstructionMaterial/store/reducer'
import reConstructionMaterialReducer from '../../containers/NRI/ReConstructionMaterial/store/reducer'
import reOrgConstructionMaterialPricePeriodChangeReducer from '../../containers/ReOrgConstructionMaterialPricePeriodChange/store/reducer'
import organizationMaterialsReducer from '../../containers/OrganizationConstructionMaterial/store/reducer'
import reInfoOrgReducer from '../../containers/ReInfoOrg/store/reducer'
import organizationConstructionMaterialPriceChangeReducer from '../../containers/OrganizationConstructionMaterialPriceChange/store/reducer'
import reAddressTypeReducer from '../../containers/NRI/ReAddressType/store/reducer'
import reRegionReducer from '../../containers/NRI/ReRegion/store/reducer'
import reAddressReducer from '../../containers/NRI/ReAddress/store/reducer'
import rePriceFormationOrderReducer from '../../containers/NRI/RePriceFormationOrder/store/reducer'
import reOrgReducer from '../../containers/NRI/ReOrgs/store/reducer'
import reOrgStoreReducer from '../../containers/ReOrgStore/store/reducer'
import reOrgNotificationReducer from '../../containers/ReOrgNotification/store/reducer'
import reOrgConversionMeasurementUnitReducer from '../../containers/ReOrgConversionMeasurementUnit/store/reducer'
import reMeasurementUnitReducer from '../../containers/NRI/ReMeasurementUnit/store/reducer'
import rePriceCalculationTypeReducer from '../../containers/NRI/RePriceCalculationType/store/reducer'
import reConstructionCategoryReducer from '../../containers/NRI/ReConstructionCategory/store/reducer'
import reCountryReducer from '../../containers/NRI/ReCountry/store/reducer'
import reAdministrativeTerritoryReducer from '../../containers/NRI/ReAdministrativeTerritory/store/reducer'
import reLocalityTypeReducer from '../../containers/NRI/ReLocalityType/store/reducer'
import reOrgConstructionMaterialCharacteristicReducer from '../../containers/ReOrgConstructionMaterialCharacteristic/store/reducer'
import rePossibleCharacteristicReducer from '../../containers/NRI/RePossibleCharacteristic/store/reducer'
import checkPricesReducer from '../../containers/PreChekingMaterialPrices/store/reducer'
import accountingPeriodReducer from '../../containers/AccountingPeriod/store/reducer'
import reAccountingPeriodReducer from '../../containers/NRI/ReAccountingPeriod/store/reducer'
import messageToAdminReducer from '../../containers/MessageToAdmin/store/reducer'
import userReducer from './user'
import priceChangesReducer from '../../containers/PriceChanges/store/reducer'
import averagePriceReducer from '../../containers/AveragePrice/store/reducer'
import reportReducer from '../../containers/Report/store/reducer'
import reSpecificWeightReducer from '../../containers/Report/ReSpecificWeight/store/reducer'
import reConstructionMaterialCharacteristicReducer from '../../containers/ReConstructionMaterialCharacteristic/store/reducer'
import reCharacteristicReducer from '../../containers/NRI/ReCharacteristic/store/reducer'
import reOrgStatusTypeReducer from '../../containers/NRI/ReOrgStatusType/store/reducer'
import reOrgTypeReducer from '../../containers/NRI/ReOrgType/store/reducer'
import reMessageToAdminTypeReducer from '../../containers/NRI/ReMessageToAdminTypes/store/reducer'
import reConstructionMaterialPeriodPriceReducer from '../../containers/ReConstructionMaterialPeriodPrices/store/reducer'
import reDistrictReducer from '../../containers/NRI/ReDistrict/store/reducer'
import helpSectionReducer from '../../containers/HelpSection/store/reducer'
import newsReducer from '../../containers/News/store/reducer'
import operatorControlReducer from '../../containers/OperatorControl/store/reducer'
import paidUserControlReducer from '../../containers/PaidUserControl/store/reducer'
import reInfoOrgTypeReducer from '../../containers/NRI/ReInfoOrgType/store/reducer'
import curatorControlReducer from '../../containers/CuratorControl/store/reducer'
import basePriceChangeReducer from '../../containers/BasePriceChange/store/reducer'
import constructionMaterialCalculationReducer from '../../containers/ConstructionMaterialCalculation/store/reducer'
import reInfoOrgConstructionMaterialPricesPerPeriodReducer from '../../containers/ReInfoOrgConstructionMaterialPricesPerPeriod/store/reducer'
import permissionForLateDataEntryReducer from '../../containers/PermissionForLateDataEntry/store/reducer'
import preliminaryOperatorCalculationReducer from '../../containers/PreliminaryOperatorCalculation/store/reducer'
import statisticsReducer from '../../containers/Statistics/store/reducer'
import webAPIReducer from '../../containers/WebAPI/store/reducer'
import curatorRegionReducer from '../../containers/CuratorsRegions/store/reducer'
import stateOrgControlReducer from '../../containers/StateOrgControl/store/reducer'
import userFileReducer from '../../containers/UserFile/store/reducer'
import reOrgConversionConstructionMaterialReducer from '../../containers/ReOrgConversionConstructionMaterial/store/reducer'
import reMeasurementUnitConvertationReducer from '../../containers/NRI/ReMeasurementUnitConvertation/store/reducer'

export default combineReducers({
	permissionForLateDataEntryReducer,
	paidUserControlReducer,
	preliminaryOperatorCalculationReducer,
	reSpecificWeightReducer,
	basePriceChangeReducer,
	reportReducer,
	reAddressReducer,
	reConstructionMaterialPeriodPriceReducer,
	reConstructionCategoryReducer,
	rePriceCalculationTypeReducer,
	reMeasurementUnitReducer,
	reOrgConversionMeasurementUnitReducer,
	reConstructionMaterialReducer,
	organizationConstructionMaterialPriceChangeReducer,
	reOrgConstructionMaterialReducer,
	organizationMaterialsReducer,
	reOrgReducer,
	reInfoOrgReducer,
	reOrgConstructionMaterialPricePeriodChangeReducer,
	rePriceFormationOrderReducer,
	userReducer,
	reCountryReducer,
	checkPricesReducer,
	accountingPeriodReducer,
	reAccountingPeriodReducer,
	messageToAdminReducer,
	reAddressTypeReducer,
	reOrgNotificationReducer,
	reRegionReducer,
	reLocalityTypeReducer,
	reAdministrativeTerritoryReducer,
	reOrgConstructionMaterialCharacteristicReducer,
	rePossibleCharacteristicReducer,
	priceChangesReducer,
	averagePriceReducer,
	reOrgTypeReducer,
	reOrgStatusTypeReducer,
	reMessageToAdminTypeReducer,
	reConstructionMaterialCharacteristicReducer,
	reCharacteristicReducer,
	reDistrictReducer,
	reOrgStoreReducer,
	helpSectionReducer,
	newsReducer,
	operatorControlReducer,
	reInfoOrgTypeReducer,
	curatorControlReducer,
	webAPIReducer,
	constructionMaterialCalculationReducer,
	reInfoOrgConstructionMaterialPricesPerPeriodReducer,
	statisticsReducer,
	curatorRegionReducer,
	stateOrgControlReducer,
	userFileReducer,
	reMeasurementUnitConvertationReducer,
	reOrgConversionConstructionMaterialReducer
})